<template>
  <tr class="param-row" :class="{ 'param-row--file': file }">
    <td class="param-row__label">
      <div
        class="param-row__label-inner"
        :class="{ 'param-row__label-inner--top': labelAlignTop }"
      >
        <div class="param-row__label-content">
          <strong class="param-row__label-text">{{ label }}{{ unused ? ' NENAUDOJAMAS' : '' }}:</strong>
          <span v-if="hint" class="param-row__label-hint">{{ hint }}</span>
        </div>
      </div>
    </td>
    <td class="param-row__value">
      <div
        class="param-row__control"
        :class="{
          'param-row__control--checkbox': checkbox,
          'param-row__control--top': labelAlignTop,
          'param-row__control--file': file,
        }"
      >
        <slot />
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ParamRow',
  props: {
    label: { type: String, required: true },
    hint: { type: String, default: null },
    checkbox: Boolean,
    unused: Boolean,
    alignTop: Boolean,
    file: Boolean,
  },
  computed: {
    labelAlignTop() {
      return this.alignTop || Boolean(this.hint)
    },
  },
}
</script>

<style lang="scss" scoped>
.param-row__label,
.param-row__value {
  vertical-align: middle !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.param-row__label {
  padding-right: 1rem !important;
}

.param-row__value {
  padding-left: 0.75rem !important;
}

.param-row__label-inner {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.param-row__label-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.param-row__label-text {
  font-size: 0.875rem;
  line-height: 1.25;
  word-break: break-word;
}

.param-row__label-hint {
  display: block;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.6);
  word-break: break-word;
}

.param-row__control {
  display: flex;
  align-items: center;
  min-height: 40px;

  ::v-deep .v-input {
    margin-top: 0 !important;
    padding-top: 0 !important;
    align-self: center;
  }

  ::v-deep .v-input__control {
    min-height: 40px;
  }

  ::v-deep .v-input__details {
    display: none !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  ::v-deep .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
}

.param-row__control--file {
  display: block;
  width: 100%;
  max-width: 100%;
  min-height: auto;

  ::v-deep > div {
    width: 100%;
    position: relative;
  }

  ::v-deep .v-input__control {
    min-height: unset !important;
  }

  ::v-deep .v-file-input.file-input-active .v-input__control > .v-input__slot {
    min-height: 80px !important;
  }

  ::v-deep .file-drop {
    width: 100% !important;
    max-height: 80px !important;
  }
}

.param-row__label-inner--top,
.param-row__control--top {
  align-items: flex-start;
  min-height: auto;
  padding-top: 0.25rem;
}

.param-row--file .param-row__label-inner {
  min-height: 80px;
}
</style>
